import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { env } from '../environments/environment';
import { SERVICES } from '../constants/services';
import { UserModel } from './UserModel';
import { BackendDataService } from '../services/backendDataService/backendDataService';
import { element } from 'protractor';
import { Cluster } from './ProposalModel';
import * as cloneDeep from 'lodash/cloneDeep';

export class CatalogueFilters{
  filter: {
    brands:Array<string>,
    collectionCode:Array<String>,
    colorCode:Array<string>,
    distrCh:string,
    features: Array<string>,
    fittingCode: Array<string>,
    genderCode: Array<string>,
    materialGroupCode: Array<string>,
    salesOrg: string,
    countryCode:string,
    seasonCodeAndYear: Array<string>,
    size: Array<string>,
    opticals: Array<string>
  }
  search:string;
  offset:number;
  limit:number;
  sortBy:string;
  sortOrder:string;
  username: string;
}

export class ArticleLink {
  link: string;
  type: string;
  skuCode: string;
  blueLight: boolean;
}

export class ArticleModel {
  derivedArticleName: string;
  advertising: boolean;
  bestSeller: boolean;
  bridgeLength: string;
  brandCode: string;
  colorCode: string;
  colorDescr: string;
  collectionDescr: string;
  diagonalLength: string;
  eanCode: string;
  easyAssembly: boolean;
  edMeasurements: string;
  fashionGrade: string;
  flex: boolean;
  frontMainColCode: string;
  frontMainColDesc: string;
  frontMarketingDescr: string;
  heroProj: boolean;
  lenMaterialCode: string;
  lensHeight: string;
  lensMainColCode: string;
  lensMainColDescr: string;
  lensMarkDescr: string;
  lensMaterialDescr: string;
  lensTreatmentCode: string;
  lensTreatmentDescr: string;
  light: boolean;
  limitedEdition: boolean;
  myopia: boolean;
  polarized: boolean;
  selected:boolean=false;
  progressive: boolean;
  seasonCode: string;
  seasonCodeDescr: string;
  size: string;
  skuCode: string;
  skuDescr: string;
  smartCurvy: boolean;
  styleCode: string;
  templeLength: string;
  templeMainColCode: string;
  templeMainColDescr: string;
  templeMarkDescr: string;
  upcCode: string;
  xl: boolean;
  xs: boolean;
  year: string;
  convertible: boolean;
  materialGroupCode: string;
  price: {
    curr: string,
    custCountry: string,
    customer: string,
    description: string,
    distrCh: string,
    name: string,
    pricingDate: string,
    prodHierarchy: string,
    rspNet: string,
    salesOrg: string,
    skuCode: string,
    wshGross: string,
    wshpNet: string
  }
  images: {
    cat: {xxl: {filename: string, imageSize: {width: number, height: number}}, s: {filename: string, imageSize: {width: number, height: number}}, xs: {filename: string, imageSize: {width: number, height: number}}}
    fom: {xxl: {filename: string, imageSize: {width: number, height: number}}, s: {filename: string, imageSize: {width: number, height: number}}, xs: {filename: string, imageSize: {width: number, height: number}}}
    front: {xxl: {filename: string, imageSize: {width: number, height: number}}, s: {filename: string, imageSize: {width: number, height: number}}, xs: {filename: string, imageSize: {width: number, height: number}}}
    lat: {xxl: {filename: string, imageSize: {width: number, height: number}}, s: {filename: string, imageSize: {width: number, height: number}}, xs: {filename: string, imageSize: {width: number, height: number}}}
  };
  quantity: string;
  tags: string;
  seasonYears: string;
  derivedNewFlag: boolean;
  clusters:Array<Cluster>;
  blueLight: boolean;
  antiReflect: boolean;
  photocromatic: boolean;
  is3dArticle: boolean;
  family: string;
  derivedTheme: string;
}

@Injectable()
export class ModelsModel {
    allArePresent: boolean;
    someArePresent: boolean;
    materialGroupCode: string;
    materialGroupDescr: string;
    materialCode: string;
    styleName: string;
    styleCode: string;
    brandLineCode: string;
    brandLineDescr: string;
    brandCode: string;
    brandName: string;
    genderCode: string;
    genderDescr: string;
    fittingCode: string;
    fittingDescr: string;
    frontMainMatCode: string;
    frontMainMatDescr: string;
    frontSecMatCode: string;
    frontSecMatDesc: string;
    templeMainMatCode: string;
    templeMainMatDescr: string;
    templeSecMatCode: string;
    templeSecMatDescr: string;
    shapeCode: string;
    shapeDescr: string;
    nichelFree: boolean;
    lensBaseCode: string;
    lensBaseDescr: string;
    weight: string;
    conceptDescr: string;
    year: string;
    seasonCode: string;
    seasonCodeDescr: string;
    collectionCode: string;
    collectionDescr: string;
    convertible: boolean;
    hingeCode: string;
    hingeDescr: string;
    articles:Array<ArticleModel>;
    polarized:boolean;
    images: {
      cat: {xxl: {filename: string, imageSize: {width: number, height: number}}, s: {filename: string, imageSize: {width: number, height: number}}, xs: {filename: string, imageSize: {width: number, height: number}}}
      fom: {xxl: {filename: string, imageSize: {width: number, height: number}}, s: {filename: string, imageSize: {width: number, height: number}}, xs: {filename: string, imageSize: {width: number, height: number}}}
      front: {xxl: {filename: string, imageSize: {width: number, height: number}}, s: {filename: string, imageSize: {width: number, height: number}}, xs: {filename: string, imageSize: {width: number, height: number}}}
    };
    rsp:number;
    wsh:number;
    seasonYears: string;
    derivedNew: boolean;
    derivedAdv: boolean;
    derivedPl: boolean;
    imageToView: string;
    contenutoMultimediale: boolean;
    bestSeller: boolean;
    derivedBlueLight: boolean;

  constructor(private http?: HttpClient, private userModel?: UserModel, public backend?:BackendDataService) {
  }

  async countModelsFromBrand(filters:CatalogueFilters) {
    let count:number = 0;
    
    filters.filter.distrCh = this.userModel.currentDivision.distrCh;
    filters.filter.salesOrg = this.userModel.currentDivision.salesOrg;
    filters.filter.countryCode = this.userModel.currentDivision.countryCode;
    filters.username = this.userModel.username;
    await this.backend.request(SERVICES["CATALOG"].count,filters).then((data:number) => {
      count = data["count"];
    }).catch((error) => {
      console.log(error);
    })
    return count;
  }

  async getLinkFromStyleCode(styleCode: string) {
    let listLink: Array<ArticleLink> = [];
    return this.backend.get(SERVICES["CATALOG"].linkVari+"/"+styleCode).then((data:Array<ArticleLink>) => {
      listLink = data;
      return listLink;
    }).catch((error) => {
      console.log(error);
      return listLink;
    });
  }
 

  async getModelsFromBrand(filter:CatalogueFilters):Promise<Array<ModelsModel>> {
    let listModels:Array<ModelsModel> = [];
    filter.filter.distrCh = this.userModel.currentDivision.distrCh;
    filter.filter.salesOrg = this.userModel.currentDivision.salesOrg;
    filter.filter.countryCode = this.userModel.currentDivision.countryCode;
    filter.username = this.userModel.username;
    return this.backend.request(SERVICES["CATALOG"].list, filter).then((data:Array<ModelsModel>) => {
      listModels = data;
      listModels.forEach(element => {
        element.brandName = this.userModel.getBrandNameFromCode(element.brandCode);
        element.seasonYears = element.seasonCode + " " + element.year.substring(2,4);
        this.backend.getImageUrl(element);
        // element.filterTreD = true; per visualizzare nuova icona filterTreD mock
        // element.bestSeller = true; per visualizzare nuova icon BS mock
        // element.derivedBlueLight = true;  //visualizzare nuova icon BL
      });
      return listModels;
    }).catch((error) => {
      console.log(error);
      return listModels;
    });
  }

  async getArticlesFromModel(styleCode: string, filterModel?: any) {
    let listArticles: Array<ArticleModel> = [];
    
    let filter = {
      distrCh: this.userModel.currentDivision.distrCh,
      salesOrg: this.userModel.currentDivision.salesOrg,
      countryCode: this.userModel.currentDivision.countryCode,
      styleCode: styleCode,
      username: this.userModel.username,
      seasonCodeAndYear: (filterModel && filterModel.filter.onlyFiltered) ? filterModel.filter.seasonCodeAndYear : [],
      theme: (filterModel && filterModel.filter && filterModel.filter.theme) ? filterModel.filter.theme : []
    }
    return this.backend.request(SERVICES["ARTICLES"].list, filter).then((data:Array<ArticleModel>) => {
      listArticles = data;
      let elementWithFOM = listArticles.filter((element) => {
        return element.images.fom && (element.images.fom.s && element.images.fom.s.filename) || (element.images.fom.xs && element.images.fom.xs.filename) || (element.images.fom.xxl && element.images.fom.xxl.filename)
      });
      let imageFomForAll = (elementWithFOM && elementWithFOM.length > 0)? (JSON.parse(JSON.stringify(elementWithFOM[0].images))) : undefined;
      console.log(elementWithFOM);
      localStorage.setItem("articleFomDetail", JSON.stringify(elementWithFOM[0])); //Aggiunto per KVS-194
      listArticles.forEach((element) => {
        element.seasonYears = element.seasonCode + " " + element.year.substring(2,4);
        this.backend.getImageUrl(element,imageFomForAll);
        // element.bestSeller = true; per visualizzare nuova icona BS mock
        // element.blueLight = true; // per visualizzare nuova icona BL
      })
      return listArticles;
    }).catch((error) => {
      console.log(error);
      return listArticles;
    });
  }

  calculatePolarize(articles: Array<ArticleModel>):boolean {
    let art:ArticleModel =  articles.find((el) => {
      return el.polarized
    })
    if(art) {
      return true;
    } else {
      return false;
    }
  }

  getArticleFromProposal(filter, item) {
    let filters = {
      id: filter.idProposal,
      limit: item.articleCount,
      offset: 0
    }
    let listOfModels: Array<any> = [];
    let listArticles: Array<ArticleModel> = [];
    return this.backend.request(SERVICES["PROPOSALS"].getArticles, filters).then((el) => {
      listOfModels = el.proposal.models;
      listOfModels.forEach((model) => {
        model.articles.forEach((article) => {
          if(article.quantity) {
            article.details.quantity = article.quantity;
          }
          if(article.tags) {
            article.details.tags = article.tags;
          }
          if(article.clusters) {
            article.details.clusters = article.clusters;
          }
          listArticles.push(article.details);
        })
      })
      return listArticles;
    }).catch((error) => {
      console.log(error);
      return listArticles;
    });
  }

  getArticleFromEAN(codEan) {
    let article: ArticleModel;
    let url = SERVICES["ARTICLES"].eanCode + "/" + codEan;
    return this.backend.get(url).then((data) => {
      article = data;
      return article;
    }).catch((error) => {
      console.log(error);
      return null;
    }); 
  }

  getArticleFromUPC(upcCode) {
    let article: ArticleModel;
    let url = SERVICES["ARTICLES"].upcCode + "/" + upcCode;
    return this.backend.get(url).then((data) => {
      article = data;
      return article;
    }).catch((error) => {
      console.log(error);
      return null;
    }); 
  }
}